import { Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import BackofficePage from '@/hoc/BackofficePage'
import routesConfig from './config'
import { SnackbarProvider } from 'baseui/snackbar'
import Home from '@/containers/HomePage'
import CarbonOffsets from '@/containers/CarbonOffsetManagement'
import Dashboard from '@/containers/DashboardPage'
import TelesalesForm from '@/containers/SubscriptionFormPage'
import SubscriptionForm from '@/containers/SubscriptionFormPageNew'
import ErrorPage from '@/containers/ErrorPage/ErrorPage'
import UsersManagement from '@/containers/UsersManagement'
import ServicesStatus from '@/containers/ServicesStatus'
import OfficesManagement from '@/containers/OfficesManagement'
import AssistanceProducts from '@/containers/AssistanceProductsManagement/AssistanceProducts'
import MonConseillerPersoProducts from '@/containers/MonConseillerPersoProductsManagement/MonConseillerPersoProducts'
import OrganizationRouter from '@/containers/OrganizationsManagement'
import ComparatorRouter from '@/containers/OrganizationsManagement/ComparatorRouter'
import ProviderOptionsManagement from '@/containers/ProviderOptionsManagement'
import DevTools from '@/containers/DevTools'
import DevToolsNew from '@/containers/DevToolsNew'
import IpAddressWhitelistManagement from '@/containers/IpAddressWhitelistManagement'
import { snackBarOverrides } from '@/containers/SubscriptionFormPage/ModulesPanel/styled-components'
import ClientCallbacksPage from '@/containers/ClientCallbacksPage'
import AdditionalProductsTools from '@/containers/AdditionalSalesManagement/AdditionalProductsTools'
import ContainerErrorBoundary from '@/shared/components/ContainerErrorBoundary'
import DashboardV2 from '@/containers/DashboardPageV2'

const withErrorBoundary = (component, name) => (
  <ContainerErrorBoundary containerName={name}>
    <Suspense fallback='loading'>{component}</Suspense>
  </ContainerErrorBoundary>
)

const CustomRoutes = () => {
  return (
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
      }}
    >
      <SnackbarProvider overrides={snackBarOverrides()}>
        <BackofficePage>
          <Routes>
            <Route path={routesConfig('home')} element={withErrorBoundary(<Home />, 'Home')} />
            <Route path={routesConfig('services-status')} element={withErrorBoundary(<ServicesStatus />, 'Services Status')} />
            <Route path={routesConfig('assistance-management')} element={withErrorBoundary(<AssistanceProducts />, 'Assistance Products')} />
            <Route
              path={routesConfig('mon-conseiller-perso-management')}
              element={withErrorBoundary(<MonConseillerPersoProducts />, 'Mon Conseiller Perso')}
            />
            <Route path={routesConfig('carbon-offset')} element={withErrorBoundary(<CarbonOffsets />, 'Carbon Offset')} />
            <Route
              path={routesConfig('subscriptions-list-telesales')}
              element={withErrorBoundary(<Dashboard type='overview' />, 'Dashboard Overview')}
            />
            <Route
              path={routesConfig('subscriptions-list-websales')}
              element={withErrorBoundary(<Dashboard type='websales' />, 'Dashboard Websales')}
            />
            <Route path={routesConfig('telesales-form')} element={withErrorBoundary(<TelesalesForm />, 'Telesales Form')} />
            <Route path={routesConfig('telesales-form-v2')} element={withErrorBoundary(<SubscriptionForm />, 'Subscription Form')} />
            <Route path={routesConfig('dev-tools')} element={withErrorBoundary(<DevTools />, 'Dev Tools')} />
            <Route path={routesConfig('dev-tools-v2')} element={withErrorBoundary(<DevToolsNew />, 'Dev Tools V2')} />
            <Route path={routesConfig('organizations-management')} element={withErrorBoundary(<OrganizationRouter />, 'Organizations')} />
            <Route path={routesConfig('comparator-management')} element={withErrorBoundary(<ComparatorRouter />, 'Comparators')} />
            <Route path={routesConfig('provider-options')} element={withErrorBoundary(<ProviderOptionsManagement />, 'Provider Options')} />
            <Route path={routesConfig('users-management')} element={withErrorBoundary(<UsersManagement />, 'Users Management')} />
            <Route path={routesConfig('client-callbacks')} element={withErrorBoundary(<ClientCallbacksPage />, 'Client Callbacks')} />
            <Route
              path={routesConfig('ip-addresses-management')}
              element={withErrorBoundary(<IpAddressWhitelistManagement />, 'IP Address Whitelist')}
            />
            <Route path={routesConfig('offices-management')} element={withErrorBoundary(<OfficesManagement />, 'Offices')} />
            <Route path={routesConfig('additional-products-management')} element={withErrorBoundary(<AdditionalProductsTools />, 'Additional Products')} />
            <Route path={routesConfig('contracts-list')} element={withErrorBoundary(<DashboardV2 />, 'Contracts')} />
            <Route path='' element={<Navigate to={routesConfig('home')} />} />
            <Route path='login' element={<Navigate to={routesConfig('home')} />} />
            <Route path='*' element={<ErrorPage />} />
          </Routes>
        </BackofficePage>
      </SnackbarProvider>
    </BrowserRouter>
  )
}

export default CustomRoutes
